import { render } from "./input.vue?vue&type=template&id=4f2906a2"
import script from "./input.vue?vue&type=script&lang=js"
export * from "./input.vue?vue&type=script&lang=js"
script.render = render

export default script